/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    compact: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    flow: false,
    stacked: false,
    componentClass: 'ul',
};

const ListItem = (props) => {
    const classNames = [
        'c-list',
        props.flow ? 'c-list--flow' : '',
        props.stacked ? 'c-list--stacked' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

ListItem.propTypes = propTypes;

ListItem.defaultProps = defaultProps;

export default ListItem;
